import { render, staticRenderFns } from "./ImportacaoMaryKay.vue?vue&type=template&id=111072e6"
import script from "./ImportacaoMaryKay.vue?vue&type=script&lang=ts"
export * from "./ImportacaoMaryKay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports